
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';function Punetoimagicacab() {



    const cardData =
    {
        keyword: '  Pune to Imagica Cab',
        heading: 'Prince Cabs:  Pune to Imagica Cab',
        headingDescription: 'Prince Cabs offers convenient Pune to Imagica Cab services, perfect for family outings, school trips, corporate tours, and weekend getaways. Our fleet of comfortable sedans, SUVs, and luxury cars ensures a safe and enjoyable ride to Imagica, one of India’s most popular theme parks. With professional drivers, timely pickups, and flexible travel options, we make your journey from Pune to Imagica stress-free and fun-filled. Enjoy a smooth travel experience with Prince Cabs’ trusted cab service to Imagica, designed for affordability, reliability, and complete comfort.',

        top: 'Top Places to Visit in Imagica with Prince Cabs',

"topPlaces": [
  {
    "title": "Imagicaa Theme Park",
    "description": "Imagicaa Theme Park is the centerpiece of the destination, offering world-class rides, shows, and entertainment for all ages. It is often called the ‘Disneyland of India,’ with attractions inspired by international theme parks. Families enjoy thrill rides, kid-friendly zones, and live performances throughout the day. The park’s vibrant ambiance creates a festive atmosphere. Seasonal events like Halloween and Christmas add extra excitement. It is the ultimate spot for fun and adventure."
  },
  {
    "title": "Nitro Roller Coaster",
    "description": "Nitro is one of the tallest and fastest roller coasters in India, making it the star attraction of Imagicaa. With thrilling twists, turns, and steep drops, it provides an adrenaline rush like no other. Riders soar above the landscape while experiencing high-speed thrills. Safety and world-class design make it suitable for adventure enthusiasts. It’s a must-try for thrill seekers visiting the park. Nitro defines the extreme side of Imagicaa’s entertainment."
  },
  {
    "title": "Deep Space Roller Coaster",
    "description": "Deep Space is India’s first indoor dark roller coaster, taking visitors on a simulated journey through outer space. The ride begins with a thrilling launch and zooms through glowing galaxies and cosmic effects. It combines speed, science fiction, and creativity. Visitors love the immersive storytelling and space-themed design. It is suitable for both families and thrill-seekers. This unique ride adds futuristic excitement to Imagicaa."
  },
  {
    "title": "Alibaba Aur Chalis Chor Ride",
    "description": "This interactive dark ride brings the Arabian Nights tale of Alibaba and the 40 Thieves to life. Visitors sit in moving carts and shoot laser beams at animated targets to defeat the thieves. The ride combines gaming with storytelling, making it popular among kids and adults. Colorful sets, sound effects, and action sequences create an engaging experience. It is one of the most fun-filled family rides in the park. Perfect for those who enjoy interactive adventures."
  },
  {
    "title": "Mr. India Ride",
    "description": "Based on the Bollywood classic, the Mr. India ride is a motion-simulator experience. Visitors join Mogambo, Seema, and Arun in an action-packed adventure against villains. Cutting-edge 3D visuals and motion effects make it thrilling and nostalgic. Fans of the movie love this unique recreation. It is a perfect blend of cinema and theme park technology. This attraction adds Bollywood charm to Imagicaa."
  },
  {
    "title": "Imagicaa Water Park (Aqua Imagicaa)",
    "description": "Aqua Imagicaa is the water park section offering slides, wave pools, and lazy rivers. Popular rides include Loopy Woopy, Zip Zap Zoom, and the Swirl Whirl. Families enjoy the beach-themed wave pool and kids’ play zones. The water park is especially popular during summer, offering refreshing fun. Food courts and lounging areas add comfort. It’s a tropical paradise for those who love water adventures."
  },
  {
    "title": "Snow Park",
    "description": "Imagicaa Snow Park lets visitors enjoy snow activities in a controlled environment, even in hot summers. Visitors can experience snowfall, ice slides, snowball fights, and igloos. The park maintains sub-zero temperatures for authenticity. Families and kids love playing in the snow without traveling to the mountains. Warm jackets and boots are provided for comfort. It offers a unique winter wonderland experience in Maharashtra."
  },
  {
    "title": "House of Stars (Bollywood Experience)",
    "description": "House of Stars is India’s first Bollywood Hall of Fame inside Imagicaa. Visitors can interact with life-size wax figures of Bollywood celebrities. It features sets and props that recreate famous movie scenes. Tourists can click photos with their favorite stars in iconic poses. The attraction adds glamour and excitement to the park. It is perfect for Bollywood fans and selfie enthusiasts alike."
  },
  {
    "title": "Novotel Imagicaa Khopoli",
    "description": "Novotel Imagicaa is a luxury hotel located next to the theme park, offering a comfortable stay for families and groups. The resort features modern rooms, swimming pools, restaurants, and spa facilities. Guests enjoy the convenience of direct park access and special package deals. It is ideal for weekend getaways and celebrations. Staying here makes the Imagicaa experience more relaxing and memorable. It combines hospitality with entertainment seamlessly."
  },
  {
    "title": "Imagicaa Parade and Live Shows",
    "description": "Every evening, Imagicaa hosts colorful parades with dancers, mascots, and entertainers in vibrant costumes. The live shows include acrobatics, magic performances, and cultural showcases. Visitors love the festive atmosphere these events create. The parades provide a perfect ending to a day filled with rides and fun. They highlight the creativity and global appeal of Imagicaa. Families especially enjoy the lively and interactive entertainment."
  }
],


"services": [
    {
        "name": "Pune to Imagica Cab",
        "description": "Enjoy a comfortable and hassle-free cab ride from Pune to Imagica Theme Park. Whether you’re traveling with family, friends, or solo, our well-maintained vehicles and experienced drivers ensure a safe and timely journey. We offer door-to-door pickup and drop, flexible scheduling, and transparent pricing for a seamless travel experience."
    },
    {
        "name": "Pune to Adlabs Imagica Cab Charges",
        "description": "Looking for affordable cab charges from Pune to Adlabs Imagica? We provide competitive pricing with no hidden fees, ensuring you get the best value for your money. Our vehicles are regularly sanitized and maintained for your safety, and our drivers are professional and courteous, making your trip pleasant and budget-friendly."
    },
    {
        "name": "Pune to Imagica Taxi",
        "description": "Book a reliable taxi from Pune to Imagica for a comfortable and timely journey. Our fleet includes sedans and SUVs equipped with AC and ample luggage space, suitable for families and groups. Enjoy courteous service, door-to-door convenience, and flexible pickup options tailored to your schedule."
    },
    {
        "name": "Pune to Imagica Cab Fare",
        "description": "Get transparent and competitive cab fares for your trip from Pune to Imagica. We offer fixed pricing packages and customizable options depending on your travel needs, whether it’s a one-way trip or a round trip. Our fare structure is designed to provide value without compromising comfort and safety."
    },
    {
        "name": "Pune to Imagica Taxi Service",
        "description": "Experience professional taxi service from Pune to Imagica with our fleet of well-maintained vehicles. Our drivers are experienced, ensuring safe navigation through traffic and a smooth ride. We prioritize your comfort and punctuality, making sure you arrive relaxed and ready to enjoy your day at the theme park."
    },
    {
        "name": "Pune to Imagica Cab Service",
        "description": "Our Pune to Imagica cab service is designed to offer a seamless travel experience for tourists and locals alike. With flexible booking options, reliable vehicles, and friendly drivers, we make your trip hassle-free. Whether it’s for leisure or group tours, we accommodate all your transportation needs."
    },
    {
        "name": "Pune to Adlabs Imagica Cab",
        "description": "Travel conveniently to Adlabs Imagica from Pune with our dedicated cab service. Perfect for families, couples, and groups, our vehicles offer comfortable seating and modern amenities. Enjoy door-to-door service, on-time pickups, and courteous drivers who assist you throughout the journey."
    },
    {
        "name": "Pune to Imagica Taxi Price",
        "description": "Check out our affordable taxi prices for Pune to Imagica trips. We offer competitive rates with no surprise charges, ensuring a cost-effective and comfortable travel option. Our pricing is transparent, and we provide instant booking confirmation for your convenience."
    },
    {
        "name": "Pune to Imagica Innova Crysta",
        "description": "Travel in premium comfort with our Innova Crysta cab service from Pune to Imagica. The Innova Crysta offers spacious interiors, advanced features, and a smooth ride, making it ideal for families and groups seeking a luxury travel experience. Our professional drivers guarantee punctuality and safety."
    },
    {
        "name": "Pune to Imagica Dzire Taxi",
        "description": "Choose our Toyota Dzire taxi for a comfortable and economical trip from Pune to Imagica. This sedan is perfect for small families and couples, offering air conditioning and smooth rides with experienced drivers ensuring a pleasant journey."
    },
    {
        "name": "Pune to Imagica Etios Cab",
        "description": "Book our Toyota Etios cab service for a budget-friendly yet comfortable ride from Pune to Imagica. Ideal for solo travelers and small groups, this sedan offers reliable performance, clean interiors, and courteous drivers for a stress-free trip."
    },
    {
        "name": "Pune to Imagica Family Cab",
        "description": "Our family cab service from Pune to Imagica caters specifically to families needing extra space and comfort. With child-friendly amenities, ample luggage capacity, and professional drivers, we ensure a safe and enjoyable ride for all family members."
    }
],
"tableData": [
    ["Pune to Imagica Cab", "Pune to Adlabs Imagica Cab Charges"],
    ["Pune to Imagica Taxi", "Pune to Imagica Cab Fare"],
    ["Pune to Imagica Taxi Service", "Pune to Imagica Cab Service"],
    ["Pune to Adlabs Imagica Cab", "Pune to Imagica Taxi Price"],
    ["Pune to Imagica Innova Crysta", "Pune to Imagica Dzire Taxi"],
    ["Pune to Imagica Etios Cab", "Pune to Imagica Family Cab"]
],


"whychoose": [
    {
        "WhyChooseheading": "Convenient Pune to Imagica Cab Service",
        "WhyChoosedescription": "Prince Cabs provides reliable and timely cab services from Pune to Imagica, ideal for families, groups of friends, and corporate outings heading for a fun-filled day. Whether you're visiting Imagica Theme Park, Water Park, or Snow Park, our cab service ensures a stress-free start and end to your adventure with door-to-door pickup and drop."
    },
    {
        "WhyChooseheading": "Comfortable and Spacious Vehicles for All Group Sizes",
        "WhyChoosedescription": "We offer a range of well-maintained, air-conditioned cabs including hatchbacks, sedans, SUVs, and tempo travellers to suit every group size and budget. Our vehicles come with spacious seating, ample luggage space, and clean interiors so you can relax and enjoy your ride to Imagica with family or friends in total comfort."
    },
    {
        "WhyChooseheading": "Experienced Drivers Who Know the Route Well",
        "WhyChoosedescription": "Our professional drivers are familiar with the Pune to Khopoli route and know the fastest and safest ways to reach Imagica, even during peak travel times. They ensure smooth navigation through expressways, safe driving, and can also suggest convenient halts for breakfast or refreshment en route."
    },
    {
        "WhyChooseheading": "Flexible Booking Options with Timely Pickups",
        "WhyChoosedescription": "Book a one-way cab, round-trip, or full-day rental based on your Imagica plan. We offer early morning pickups, late evening returns, or overnight options so you can enjoy the park at your own pace. Booking is quick and easy via call, website, or WhatsApp, and we offer instant confirmation."
    },
    {
        "WhyChooseheading": "Clean, Sanitized Vehicles with Safety First Approach",
        "WhyChoosedescription": "Every cab undergoes thorough cleaning and sanitization before and after the trip to ensure maximum hygiene. Our vehicles are regularly serviced and equipped with safety features like seat belts, GPS tracking, and first-aid kits, making your family outing both safe and comfortable."
    },
    {
        "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
        "WhyChoosedescription": "Our Pune to Imagica cab fares are clearly mentioned with no surprises at the end of the ride. We believe in transparent billing with no hidden costs, and offer multiple secure payment options including UPI, debit/credit cards, net banking, and cash."
    },
    {
        "WhyChooseheading": "Dedicated Customer Support for a Smooth Experience",
        "WhyChoosedescription": "Our support team is available 24/7 to assist with bookings, rescheduling, route information, or on-trip help. From pickup to drop-off, we ensure your trip to Imagica is smooth, well-coordinated, and completely hassle-free so you can focus on enjoying your day at the park."
    }
]


























    }

const faqData = [
    {
        question: 'Does Prince Cabs offer Pune to Imagica cab services?',
        answer: 'Yes, Prince Cabs provides comfortable and reliable cab services from Pune to Imagica Theme Park, perfect for family outings and group visits.',
    },
    {
        question: 'What types of cabs are available for Pune to Imagica travel?',
        answer: 'We offer hatchbacks, sedans, SUVs, and tempo travellers to accommodate solo travelers, families, and larger groups with ease.',
    },
    {
        question: 'Is the Pune to Imagica cab ride suitable for families and kids?',
        answer: 'Absolutely! Our vehicles are clean, air-conditioned, and maintained for comfort and safety, making them ideal for family trips to Imagica.',
    },
    {
        question: 'Can I customize my trip with stopovers on the way to Imagica?',
        answer: 'Yes, you can plan your own itinerary with flexible pickup and drop locations, and optional stops en route to Imagica.',
    },
    {
        question: 'What are the cab charges for Pune to Imagica trips?',
        answer: 'Fares depend on the vehicle type, travel duration, and any special requests. Contact Prince Cabs for a detailed and competitive quote.',
    },
    {
        question: 'How do I book a Pune to Imagica cab with Prince Cabs?',
        answer: 'Booking is simple—contact us via phone or website with your travel details, and we’ll help you choose the best cab for your trip.',
    },
    {
        question: 'Are the cabs sanitized and well-maintained for safe travel?',
        answer: 'Yes, all our vehicles are regularly sanitized, cleaned, and serviced to ensure a safe and pleasant journey to Imagica.',
    },
];

const testimonials = [
    {
        name: "Mr. Vikram Joshi",
        position: "Family Traveler",
        text: "Our Pune to Imagica trip with Prince Cabs was fantastic. The driver was friendly, the cab was spacious, and everything went smoothly.",
        image: "/img/testimonial/testimonial-thumb-imagica-1.png",
    },
    {
        name: "Ms. Richa Deshmukh",
        position: "Group Traveler",
        text: "Prince Cabs made our visit to Imagica hassle-free. The vehicle was clean, and the service was punctual and reliable.",
        image: "/img/testimonial/testimonial-thumb-imagica-2.png",
    },
];




























    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9284304420",
            "+91 8308844163",


        ],
        email: "booking@princecab.com"
    };


    const Images = [
  { place: "/images/keyword/1.jpg",  text: "Innova Cab on Rent in Hadapsar Pune",            link: "innova-cab-on-rent-in-hadapsar-pune" },
  { place: "/images/keyword/2.jpg",  text: "Pune To Mahabaleshwar Innova Cab",                link: "pune-to-mahabaleshwar-innova-cab" },
  { place: "/images/keyword/3.jpg",  text: "Pune to Shirdi Innova Cab Booking",               link: "pune-to-shirdi-innova-cab-booking" },
  { place: "/images/keyword/4.jpg",  text: "Pune to Mumbai Airport Innova Cab",               link: "pune-to-mumbai-airport-innova-cab" },
  { place: "/images/keyword/5.jpg",  text: "Pune to Goa Innova Cab",                          link: "pune-to-goa-innova-cab" },
  { place: "/images/keyword/6.jpg",  text: "Pune to Ashtavinayak Innova Tour Package",        link: "pune-to-ashtavinayak-innova-tour-package" },
  { place: "/images/keyword/7.jpg",  text: "Sedan Cab Service in Pune",                       link: "sedan-cab-service-in-pune" },
  { place: "/images/keyword/8.jpg",  text: "Etios Cab for Outstation in Pune",                link: "etios-cab-for-outstation-in-pune" },
  { place: "/images/keyword/9.jpg",  text: "Toyota Etios Cab Booking in Pune",                link: "toyota-etios-cab-booking-in-pune" },
  { place: "/images/keyword/10.jpg", text: "Swift Dzire On Rent Pune",                        link: "swift-dzire-on-rent-pune" },
  { place: "/images/keyword/11.jpg", text: "Pune to Shirdi Swift Dzire Cab",                  link: "pune-to-shirdi-swift-dzire-cab" },
  { place: "/images/keyword/12.jpg", text: "Pune to Mahabaleshwar Swift Dzire Cabs",          link: "pune-to-mahabaleshwar-swift-dzire-cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Dzire Cab",                        link: "pune-to-mumbai-dzire-cab" },
  { place: "/images/keyword/14.jpg", text: "Pune to Gujarat Cab",                             link: "pune-to-gujarat-cab" },
  { place: "/images/keyword/15.jpg", text: "Pune to Rajasthan Cab",                           link: "pune-to-rajasthan-cab" },
  { place: "/images/keyword/16.jpg", text: "Pune to Indore Cab Booking",                      link: "pune-to-indore-cab-booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Vijayawada Cabs",                         link: "pune-to-vijayawada-cabs" },
  { place: "/images/keyword/18.jpg", text: "Pune to Bangalore Cab",                           link: "pune-to-bangalore-cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Hyderabad Cab",                           link: "pune-to-hyderabad-cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Belgaum Cab",                             link: "pune-to-belgaum-cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mahabaleshwar Cab",                       link: "pune-to-mahabaleshwar-cab" },
  { place: "/images/keyword/22.jpg", text: "Pune to Panchgani Cab",                           link: "pune-to-panchgani-cab" },
  { place: "/images/keyword/23.jpg", text: "Pune to Goa Cab",                                 link: "pune-to-goa-cab" },
  { place: "/images/keyword/24.jpg", text: "Pune to Bhimashankar Cab",                        link: "pune-to-bhimashankar-cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Shirdi Cab",                              link: "pune-to-shirdi-cab" },
];




    const images = [
        { src: "/images/gallery/1.jpg", alt: "Image 1" },
        { src: "/images/gallery/5.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/4.jpg", alt: "Image 1" },
        { src: "/images/gallery/6.jpg", alt: "Image 1" },

    ];



const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Imagica Cab",
  "image": "https://princecab.com/assets/images/pune-imagica-cab.jpg",
  "description": "Book Pune to Imagica cab with Prince Cabs for comfortable and affordable taxi services. Options include Innova Crysta, Dzire, and Etios cabs perfect for family trips and quick rides to Adlabs Imagica. 24/7 online booking available.",
  "brand": {
    "@type": "Brand",
    "name": "Prince Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "6300"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1800",
    "availability": "https://schema.org/InStock",
    "url": "https://princecab.com/pune-to-imagica-cab"
  }
};





    return (
        <div>
<Helmet>
  <title>Pune to Imagica Cab | Affordable Taxi Service | Prince Cabs</title>
  <meta
    name="description"
    content="Prince Cabs provides Pune to Imagica cab service with Innova, Dzire, and Etios taxis. Perfect for family trips to Adlabs Imagica with affordable fares and 24/7 online booking."
  />
  <meta
    name="keywords"
    content="Pune to Imagica Cab, Pune to Adlabs Imagica Cab Charges, Pune to Imagica Taxi, Pune to Imagica Cab Fare, Pune to Imagica Taxi Service, Pune to Imagica Cab Service, Pune to Adlabs Imagica Cab, Pune to Imagica Taxi Price, Pune to Imagica Innova Crysta, Pune to Imagica Dzire Taxi, Pune to Imagica Etios Cab, Pune to Imagica Family Cab"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section className="inner-banner-wrap">
                <div
                    className="inner-baner-container"
                    style={{ backgroundImage: 'url(/images/inner-banner.jpg)' }}
                >
                    <div className="container">
                        <div className="inner-banner-content">
                            <h1 className="inner-title">{cardData.keyword} </h1>
                        </div>
                    </div>
                </div>
                <div className="inner-shape"></div>
            </section>







            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/13.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#AF3125', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                             <div className="topPlaces">
  <p className="sectionLead">{cardData.top}</p>

  {cardData.topPlaces.map((place, index) => (
    <article key={index} className="placeCard" tabIndex="0">
      <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

      <div className="placeBody">
        <h4 className="placeTitle">{place.title}</h4>
        <p className="placeDesc">{place.description}</p>
      </div>

      <span className="placeArrow" aria-hidden>›</span>
    </article>
  ))}
</div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vihaan Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


 <ContactShowcase/>
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
  {Images.map((e, i) => {
    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

    return (
      <a
        key={e.link || i}
        href={href}
        className="routeItem"
        aria-label={e.text}
        {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
      >
        <div className="routeThumb">
          <img src={e.place} alt="" loading="lazy" />
        </div>

        <div className="routeMeta">
          <h6 className="routeTitle">{e.text}</h6>
          <span className="routeUnderline" />
        </div>

        <span className="routeArrow" aria-hidden>›</span>
      </a>
    );
  })}
</div>



                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                        </div> */}
<div>
  <FleetHighway/>
</div>
                            <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919284304420" className="pc-call">+91 9284304420</a>
        <a href="tel:+918308844163" className="pc-call">+91 8308844163</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919284304420"
          target="_blank" rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp me-1"></i> WhatsApp
        </a>
        <a href="tel:+919284304420" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@princecab.com" className="pc-email">
        booking@princecab.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-house-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Prince Cabs</strong><br />
        Office No 106, 2nd Floor, Nilgiri Nest Co-op Housing Society,<br />
        Pimple Gurav, Pune, Pin - 411027
      </address>
    </section>
  </div>
</div>



                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetoimagicacab;